import { createUseStyles } from "react-jss";

const styles = createUseStyles({
    joinPage: {
    // padding: "0px 54px"
  }
});

export default styles;
